// extracted by mini-css-extract-plugin
module.exports = {"customSkeleton":"Currency_customSkeleton__3tTsy"};